import { useEffect, useState } from 'react';
import { AiOutlineCreditCard, AiOutlineSwap } from 'react-icons/ai';
import {
  FaHandHoldingUsd,
  FaMoneyBillWave,
  FaMoneyCheckAlt,
  FaCoins,
  FaAward,
} from 'react-icons/fa';
import { GiReceiveMoney } from 'react-icons/gi';
import { HiOutlineArrowCircleRight, HiOutlineCreditCard } from 'react-icons/hi';
import { RiExchangeDollarLine } from 'react-icons/ri';
import { Link, useNavigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { RootState } from '../../app/store';
import BarchartComp from '../../components/barChart/BarChart';
import Card from '../../components/card/Card';
import LineChartComp from '../../components/lineChart/LineChart';
import { newsData } from '../../components/news/News';
import {
  GetDashboardEarningInfo,
  GetDashboardInfo,
  GetGraphMemberCounts,
  GetGraphPartnerPayouts,
  GetGraphTransactionsCounts,
} from '../../features/partnerSlice';
import { MdGroups, MdOutlineReceiptLong } from 'react-icons/md';

import { api } from '../../utils/api/apiClient';
import { formatDateString } from '../../assets/helper';

interface CardPath {
  [key: string]: string; // Map card title (string) to route (string)
}

const cardPaths: CardPath = {
  'Total Customers': '/reporting/customers-data',
  'Customers Data': '/reporting/customers-data',
  'Total # Transactions': '/reporting/transactions-data',
  'Total Value Transactions': '/reporting/transactions-data',
  'Partner Earnings': '/reporting/earnings-data',
  'Customer total Earning': '/reporting/earnings-data',
  'Program Booster Earnings': '/reporting/earnings-data',
  '# Enrolled Cards': '/reporting/cards-data',
};

const Dashboard = () => {
  const navigate = useNavigate();
  const [partnerData, setPartnerData] = useState<any>(null);
  const [nextBilling, setNextBilling] = useState<any>(null);
  const [nextBillQuantity, setNextBillQuantity] = useState<any>(null);
  const [campaignData, setCampaignData] = useState<any>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isNextBillingLoading, setIsNextBillingLoading] = useState(true);
  const [isCampaignDataLoading, setIsCampaignDataLoading] = useState(true);
  const {
    dashboardInfo,
    graphMemberCounts,
    graphTransactionCounts,
    GraphPartnerPayouts,
    dashboardEarningInfo,
    loadingStates,
  } = useAppSelector((state: RootState) => state.partner);

  useEffect(() => {
    // نقرأ الداتا من localStorage
    const data = localStorage.getItem('userDetails');
    if (data) {
      const parsed = JSON.parse(data);
      console.log(parsed);

      // هنا ناخد created من partnerAttrib
      const nextBillQuantity = parsed?.partner?.partnerAttrib?.find(
        (attr: any) => attr.name === 'nextBillQuantity'
      );
      setNextBillQuantity(nextBillQuantity?.value);
    }
  }, []);

  const dispatch = useAppDispatch();
  const handleCardClick = (title: string) => {
    const path = cardPaths[title];
    let activeTab: '1' | '2' | '3' | '4' = '1';

    // حدد التاب حسب الكارد
    if (title === 'Total # Transactions' || title === 'Partner Earnings') {
      activeTab = '1';
    } else if (
      title === 'Total Value Transactions' ||
      title === 'Customer total Earning'
    ) {
      activeTab = '2';
    } else if (title === 'Program Booster Earnings') {
      activeTab = '3';
    } else if (title === 'Customers Data') {
      activeTab = '4';
    }

    if (path) {
      navigate(path, { state: { activeTab } });
    }
  };

  useEffect(() => {
    const today = new Date();
    const tomorrow = new Date(today);
    tomorrow.setDate(tomorrow.getDate() + 1);
    let endDate = today;
    let startDate;
    startDate = new Date(
      tomorrow.getFullYear(),
      tomorrow.getMonth() - 5,
      tomorrow.getDate()
    );
    const date = {
      startDate: startDate?.toISOString().split('T')[0] || '',
      endDate: endDate?.toISOString().split('T')[0] || '',
      typeName: '',
    };
    if (!dashboardInfo) dispatch(GetDashboardInfo());
    dispatch(GetGraphMemberCounts(date));
    dispatch(GetGraphTransactionsCounts(date));
    dispatch(GetGraphPartnerPayouts(date));
  }, [dispatch, dashboardInfo]);
  useEffect(() => {
    if (!dashboardEarningInfo) {
      dispatch(GetDashboardEarningInfo());
    }
  }, [dashboardEarningInfo, dispatch]);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await api.post('/usr/p/c/d');
        setPartnerData(response);
        setIsLoading(false);
      } catch (error) {
        console.error('API Error:', error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await api.post('/pmo/d/n/b');
        setNextBilling(response);
        setIsNextBillingLoading(false);
      } catch (error) {
        console.error('API Error:', error);
      }
    };
    const fetchCampaignData = async () => {
      try {
        const response = await api.post('/pmo/d/s/r');
        setCampaignData(response);
        setIsCampaignDataLoading(false);
      } catch (error) {
        console.error('API Error:', error);
      }
    };
    fetchCampaignData();
    fetchData();
  }, []);
  const shouldShowBoxB = partnerData?.receivePayout === '';
  const shouldShowBoxC = !shouldShowBoxB;

  return (
    <>
      <div className='flex flex-col gap-7 max-w-[85rem] mx-auto'>
        <div>
          <h2 className=' text-white bg-primary p-4 px-8 rounded-t-lg text-xl font-semibold'>
            Program Overview
          </h2>
          <div className='p-4 border border-gray-300 rounded-b-lg shadow-md'>
            <div className='grid grid-cols-1 lg:grid-cols-2   gap-5'>
              <Card
                title='Total Members to Date'
                isLoading={loadingStates['GetDashboardInfo']}
                value={dashboardInfo?.userCount ?? '0'}
                onClick={() => handleCardClick('Total Customers')}
                icon={<MdGroups color='#1133BB' size={22} />}
                header='Member Count'
              />
              <Card
                title='Total Enrolled Cards to Date'
                isLoading={loadingStates['GetDashboardInfo']}
                value={dashboardInfo?.cardsCount ?? '0'}
                onClick={() => handleCardClick('# Enrolled Cards')}
                icon={<AiOutlineCreditCard color='#1133BB' size={22} />}
                header='Enrolled Cards'
              />
              {shouldShowBoxB && (
                <Card
                  title={formatDateString(partnerData?.payoutDate) ?? 'N/A'}
                  isLoading={isLoading}
                  value={partnerData?.available || '$0.00'}
                  onClick={() => handleCardClick('Partner Earnings')}
                  icon={<HiOutlineArrowCircleRight color='#1133BB' size={22} />}
                  header='Next Payout'
                />
              )}
              {shouldShowBoxC && (
                <Card
                  title={
                    isLoading
                      ? ''
                      : 'You need to reach $25 to qualify for payouts'
                  }
                  isLoading={isLoading}
                  value=''
                  onClick={() => handleCardClick('Partner Earnings')}
                  icon={<HiOutlineArrowCircleRight color='#1133BB' size={22} />}
                  header='Next Payout'
                />
              )}
              <Card
                title={
                  nextBilling?.date
                    ? nextBilling?.date
                    : isNextBillingLoading
                      ? ''
                      : 'Program Monthly Subscription Not Yet Started'
                }
                isLoading={isNextBillingLoading}
                value={
                  nextBilling?.value
                    ? nextBillQuantity
                      ? `$${(Number(nextBillQuantity) * nextBilling?.value).toLocaleString()}`
                      : `$${nextBilling?.value.toLocaleString()}`
                    : ''
                }
                onClick={() => handleCardClick('Partner Earnings')}
                icon={<MdOutlineReceiptLong color='#1133BB' size={22} />}
                header='Next Billing'
              />
            </div>
          </div>
        </div>
        <div>
          <div className='flex items-center gap-12  text-white bg-primary p-4 px-8 rounded-t-lg'>
            <h2 className='  text-xl font-semibold'>
              Program Booster Campaign{' '}
            </h2>
            <Link
              to='/program-booster'
              target='_blank'
              className='underline text-sm'
            >
              Read More
            </Link>
          </div>
          <div className='p-4 border border-gray-300 rounded-b-lg shadow-md'>
            <div className='grid grid-cols-1 lg:grid-cols-2   gap-5'>
              <Card
                title='Signed Up Since June 1'
                isLoading={isCampaignDataLoading}
                value={campaignData?.newMemberCount ?? '0'}
                onClick={() => handleCardClick('Customers Data')}
                icon={<FaAward color='#1133BB' size={22} />}
                header='New Member Count'
              />
              <Card
                title='Qualified Since June 1'
                isLoading={isCampaignDataLoading}
                value={campaignData?.earnCampaignRewards ?? '0'}
                onClick={() => handleCardClick('Program Booster Earnings')}
                icon={<FaCoins color='#1133BB' size={22} />}
                moreDetails='New signed up members become qualified when they enroll at-least one card within 30 days of signing up'
                header='Campaign Rewards'
              />
            </div>
          </div>
        </div>
        <div>
          <h2 className='text-white bg-primary p-4 px-8 rounded-t-lg text-xl font-semibold'>
            Current Month
          </h2>
          <div className='p-4 border border-gray-300 rounded-b-lg shadow-md'>
            <div className='grid grid-cols-1 lg:grid-cols-2  gap-5'>
              <Card
                title='Total Number of Transactions'
                isLoading={loadingStates['GetDashboardInfo']}
                value={dashboardInfo?.txnCount ?? '0'}
                onClick={() => handleCardClick('Total # Transactions')}
                icon={<AiOutlineSwap color='#1133BB' size={22} />}
                header='Transaction Count'
              />
              <Card
                title='Total Transaction Value'
                isLoading={loadingStates['GetDashboardInfo']}
                value={dashboardInfo?.totalValueTxn?.valueText ?? '0'}
                onClick={() => handleCardClick('Total Value Transactions')}
                icon={<FaMoneyCheckAlt color='#1133BB' size={22} />}
                header='Transaction Value'
              />
              <Card
                title='Current Month Partner Earnings'
                isLoading={loadingStates['GetDashboardInfo']}
                value={dashboardInfo?.totalPartnerEarnings?.valueText ?? '0'}
                onClick={() => handleCardClick('Partner Earnings')}
                icon={<FaMoneyBillWave color='#1133BB' size={22} />}
                moreDetails='This amount reflects your commission based on the potential cashback earned by your program members this month.'
                header='Partner Earnings'
              />
              <Card
                title='Current Month Member Cashback'
                isLoading={loadingStates['GetDashboardInfo']}
                value={dashboardInfo?.totalCustomerEarnings?.valueText ?? '0'}
                onClick={() => handleCardClick('Customer total Earning')}
                icon={<FaHandHoldingUsd color='#1133BB' size={22} />}
                moreDetails='This amount reflects the potential cashback earned by your program members this month.'
                header='Member Cashback'
              />
            </div>
          </div>
        </div>
        {/* <PageShdowTitle title='Program Overview' /> */}
        <div>
          <h2 className='text-white bg-primary p-4 px-8 rounded-t-lg text-xl font-semibold'>
            All Cashback to Date
          </h2>
          <div className='p-4 border border-gray-300 rounded-b-lg shadow-md'>
            <div className='grid grid-cols-1 lg:grid-cols-2 xxl:grid-cols-3 gap-5'>
              {/* New 6 Cards */}
              <Card
                title='Pending'
                isLoading={loadingStates['GetDashboardInfo']}
                value={dashboardEarningInfo?.usersPendingEarnings?.value ?? '0'}
                onClick={() => handleCardClick('Customer total Earning')}
                icon={<FaHandHoldingUsd color='#1133BB' size={22} />}
                header='Member Cashback to Date'
                moreDetails='This amount reflects the total pending cashback earned by your program members to date. Once approved, it will move to confirmed status.
'
              />
              <Card
                title='Confirmed'
                isLoading={loadingStates['GetDashboardInfo']}
                value={
                  dashboardEarningInfo?.usersConfirmedEarnings?.value ?? '0'
                }
                onClick={() => handleCardClick('Customer total Earning')}
                header='Member Cashback to Date'
                icon={<RiExchangeDollarLine color='#1133BB' size={22} />}
              />
              <Card
                title='Total Member Payouts to Date'
                isLoading={loadingStates['GetDashboardInfo']}
                value={dashboardEarningInfo?.userPayouts?.value ?? '0'}
                onClick={() => handleCardClick('Customer total Earning')}
                icon={<GiReceiveMoney color='#1133BB' size={22} />}
                header='Member Payouts'
              />
              <Card
                title='Pending'
                isLoading={loadingStates['GetDashboardInfo']}
                value={
                  dashboardEarningInfo?.partnerPendingEarnings?.value ?? '0'
                }
                onClick={() => handleCardClick('Partner Earnings')}
                icon={<HiOutlineCreditCard color='#1133BB' size={22} />}
                header='Partner Earnings to Date'
                moreDetails='This amount reflects your commission in pending status, based on the pending cashback earned by your members to date. Once approved, it will move to confirmed status.
'
              />
              <Card
                title='Confirmed'
                isLoading={loadingStates['GetDashboardInfo']}
                value={
                  dashboardEarningInfo?.partnerConfirmedEarnings?.value ?? '0'
                }
                onClick={() => handleCardClick('Partner Earnings')}
                header='Partner Earnings to Date'
                icon={<RiExchangeDollarLine color='#1133BB' size={22} />}
              />
              <Card
                title='Total Partner Payouts to Date'
                header='Partner Payouts'
                isLoading={loadingStates['GetDashboardInfo']}
                value={dashboardEarningInfo?.partnerPayouts?.value ?? '0'}
                onClick={() => handleCardClick('Partner Earnings')}
                icon={<GiReceiveMoney color='#1133BB' size={22} />}
              />
            </div>
          </div>
        </div>

        <div>
          <BarchartComp
            defaualtFiltering='6'
            title='Partner Payouts'
            isOneColumn={true}
            // data={BAR_CHART_DATA}
            data={GraphPartnerPayouts ?? []}
            dataKey1='amount'
            name1='Partner Payouts'
            chartName='PartnerPayouts'
            dollar={true}
            description='Monthly Payouts'
            isLoading={loadingStates['GetGraphPartnerPayouts']}
            isShadowBox
          />
        </div>
        <div className='grid grid-cols-1 lg:grid-cols-2 gap-5'>
          <BarchartComp
            defaualtFiltering='6'
            title='Member Count'
            isOneColumn={false}
            // data={BAR_CHART_DATA}
            data={graphMemberCounts ?? []}
            description='Active vs. Inactive Members (Active members are those that have transacted in the respective month)'
            isLoading={loadingStates['GetGraphMemberCounts']}
            isShadowBox
          />
          <LineChartComp
            defaualtFiltering='6'
            dataKey='txnCount'
            title='Transaction Count'
            name='Transaction Count'
            data={graphTransactionCounts ?? []}
            description='Total number of reward transactions'
            isShadowBox
          />
        </div>

        {/* Admin Info Section */}
        <div className='py-4 md:py-6'>
          <h2 className='text-white bg-primary p-4 px-8 rounded-t-lg text-xl font-semibold'>
            Updates
          </h2>
          <div className='p-4 border border-gray-300 rounded-b-lg shadow-md overflow-y-auto max-h-screen'>
            {/* <div className='mb-8 text-lg'>
              <strong>Next Payout Date:</strong> <span>December 25, 2024</span>
            </div>
            <div className='mb-8 text-lg'>
              <strong>Next Billing Date:</strong>{' '}
              <span>
                {subscriptionDate ??
                  'Program Monthly Subscription Not Yet Started'}
              </span>
            </div> */}
            {/* <div className='text-lg'>
              <strong>Notifications:</strong>
            </div> */}
            {newsData.map(item => (
              <div key={item.id} className='p-4 border-b last:border-b-0'>
                <h3 className='font-semibold'>{item.title}</h3>
                <p className='text-sm text-gray-600 mb-2'>{item.date}</p>
                <p className='text-gray-700 mb-4'>{item.content}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default Dashboard;
